import { Component, OnInit, ViewEncapsulation, Inject, ViewChild, ElementRef } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { FormControl, FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import { Observable } from "rxjs/Observable";
import { GeoSite } from "../../shared/interface/geosite";
import { GroupService } from "../../shared/services/group/group.service";
import { UserService } from '../../shared/services/index';
declare var L: any;

@Component({
  selector: "app-geosites",
  templateUrl: "geosites.component.html",
  styleUrls: ["./geosites.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class GeoSitesComponent implements OnInit {
  @ViewChild("geoSiteMap") geoSiteMap: ElementRef;
  geoFilterForm: FormGroup;
  private map;
  currentEdits: any = null;
  currentAdd: any = null;
  editableLayers: any = null;
  geoSiteList: any = [];
  isSubmitted: number = 0;
  categoryList: any = [];
  subCategoryList: any = [];
  focuseLayer: any = null;
  leafLayers: any = [];
  osmsearches: any = [];
  previewlayer: any = null;
  userExportPer: any;
  isAddSite: boolean = false;
  isLoadedGeo: boolean = false;
  constructor(public dialog: MatDialog,
    private fb: FormBuilder,
    private groupService: GroupService,
    private userService: UserService) { }

  private initMap(): void {
    var container = L.DomUtil.get(this.geoSiteMap.nativeElement);
    if (container != null) {
      container._leaflet_id = null;
    }
    this.map = new L.Map(this.geoSiteMap.nativeElement, {
      center: [25.13339, 55.23432],
      zoom: 15,
      markerZoomAnimation: false,
      zoomControl: false,
      preferCanvas: true
    });

  }

  ngOnInit() {
    let that = this;
    this.initMap();
    this.BindAllGeoSites();
    this.getCategoryList();
    this.addUpdateGeoSite();
    this.geoFilterForm = this.fb.group({
      siteName: "",
      city: "",
      country: "",
      categoryid: "",
      subcategoryid: ""
    });

    $(function () {

      $('body').on('click', '.previewOsmSite', function (e) {
        e.preventDefault();
        var osmsite = that.osmsearches.find(x => x.osm_id = this.getAttribute("data-id"));
        if (osmsite) {
          if (that.previewlayer)
            that.map.removeLayer(that.previewlayer);
          that.previewlayer = L.geoJSON(osmsite.geojson, { fillColor: '#0a93e2', color: '#0a93e2' }).addTo(that.map);
          that.map.fitBounds(that.previewlayer.getBounds());
        }
      });

      $('body').on('click', '.addOsmSite', function (e) {
        e.preventDefault();
        var osmsite = that.osmsearches.find(x => x.osm_id = this.getAttribute("data-id"));
        if (osmsite) {
          that.openGeoSiteDialog({ isShowGeoJson: true, geoJson: JSON.stringify(osmsite.geojson) }, '');
        }
      });

      $('body').on('click', '#mapsidenav-add', function (e) {
        e.preventDefault();
        that.openGeoSiteDialog({ isShowGeoJson: true }, '');
      });

      $('body').on('click', '#mapsidenav-expand', function (e) {
        e.preventDefault();
        $('#mapsidenav').toggleClass('open');
        $('.mpacontainer').toggleClass('slider-open');
        setTimeout(() => {
          that.map.invalidateSize();
          $('#mapsidenav-expand').toggleClass('open');
        }, 600);
        that.clearFilter();
      });

      $('body').on('click', '.regenrateView', function (e) {
        e.preventDefault();
        e.stopPropagation();
        that.isLoadedGeo = true;
        let _id = $(this).parent().attr('id');
        that.groupService.reGenrateView({ id: _id }).subscribe(
          res => {            
            that.isLoadedGeo = false;
          },
          error => {
            console.log(error);
            that.isLoadedGeo = false;
          });
      });

      $('body').on('click', '.site-item', function (e) {
        e.preventDefault();
        that.map.closePopup();
        let _id = this.getAttribute("id");
        if (that.focuseLayer) {
          that.focuseLayer.setStyle({ fillColor: '#ff5050', color: '#ff5050' });
        }
        var selectedLayer = that.leafLayers.find(x => x.options._id == _id);
        if (selectedLayer) {
          that.focuseLayer = selectedLayer;
          selectedLayer.setStyle({ fillColor: '#0a93e2', color: '#0a93e2' });
          var bounds = selectedLayer.getBounds();
          that.map.fitBounds(bounds);
        }
      });

      $('body').on('click', '#mapsidenav-collapse', function (e) {
        e.preventDefault();
        $('#mapsidenav').toggleClass('open');
        $('mpacontainer').toggleClass('slider-open');
        setTimeout(() => {
          that.map.invalidateSize();
          $('#mapsidenav-expand').toggleClass('open');
        }, 600);
        that.clearFilter();
        $('.filterFields').addClass('hidden');
      });
      $('body').on('click', '#aFilter', function () {
        that.clearFilter();
      });

      $('body').on('click', '#aSiteSearch', function (e) {
        e.preventDefault();
        var _condition = [];
        if ($('#siteName').val() != "")
          _condition.push('x.siteName.toLowerCase().includes("' + $('#siteName').val().toString().toLowerCase() + '")');
        if ($('#city').val() != "")
          _condition.push('x.city.toLowerCase().includes("' + $('#city').val().toString().toLowerCase() + '")');
        if ($('#country').val() != "")
          _condition.push('x.country.toLowerCase().includes("' + $('#country').val().toString().toLowerCase() + '")');
        if ($('#categoryid').val() != '')
          _condition.push('x.categoryid == "' + $('#categoryid').val() + '"');
        if ($('#subcategoryid').val() != '')
          _condition.push('x.subcategoryid =="' + $('#subcategoryid').val() + '"');
        if (_condition.length > 0) {
          var evalArgs = _condition.join('&&');
          let filterData = that.geoSiteList.filter(x => eval(evalArgs));
          if (filterData && filterData.length > 0) {
            that.bindGeoSites(filterData);
          }
          else {
            var _siteContainer = $('.siteResults');
            _siteContainer.empty();
            _siteContainer.html("No sites found!");
          }
        } else {
          that.bindGeoSites(that.geoSiteList);
        }
      });

    });
    this.editableLayers = new L.FeatureGroup();
    this.map.addLayer(this.editableLayers);
    this.map.addControl(new L.Control.Draw({
      edit: {
        featureGroup: this.editableLayers,
        poly: {
          allowIntersection: false
        },
        remove: false,
        edit: false
      },
      draw: {
        polyline: false,
        polygon: true,
        rectangle: true,
        marker: false,
        circle: false,
        circlemarker: false
      }
    }));
    L.control.zoom({
      position: 'bottomright'
    }).addTo(this.map);

    this.editableLayers.addEventListener('click', function (ev) {
      //clearSiteJson();
      if (that.currentEdits) {
        that.currentEdits.editing.disable();
        that.currentEdits.closePopup();
        that.currentEdits = null;
      }
      ev.layer.setStyle({ fillColor: '#ff5050', color: '#ff5050' });
      ev.layer.bindPopup(that.CreateEditMenu(ev), { closeButton: false }).openPopup();
    })

    this.map.on(L.Draw.Event.CREATED, function (event: any) {
      that.currentAdd = event.layer;
      that.editableLayers.addLayer(event.layer);
      that.openGeoSiteDialog({}, event.layer);
    });

    var googleStreets = L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
      maxZoom: 25,
      maxNativeZoom: 20,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
    });

    var googleSat = L.tileLayer('http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', {
      maxZoom: 25,
      maxNativeZoom: 20,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
    });

    var baseLayers = {
      "Street View": googleStreets,
      "Satellite View": googleSat,
    };
    var layersControl = L.control.layers(baseLayers, null, { collapsed: false });
    layersControl.addTo(this.map);
    this.map.addLayer(googleStreets);

    $('body').on('click', '#searchPlace', function (e) {
      e.preventDefault();
      that.searchOsmPlaces();
    });
  }

  searchOsmPlaces() {
    var that = this;
    var input: any = document.getElementById("searchBox");
    if (input.value) {
      $.ajax({
        url: "https://nominatim.openstreetmap.org/search.php?q=" + encodeURIComponent(input.value).replace(/%20/g, '+') + "&polygon_geojson=1&format=json",
        type: "GET",
        success: function (resp) {
          if (resp.length > 0) {
            $('.osmSearchResult').html('');
            resp = resp.filter(x => x.osm_type == 'relation' || x.osm_type == 'way');
            that.osmsearches = resp;
            resp.forEach(ol => {
              $('.osmSearchResult').append('<div class="ositem"><label>' + ol.display_name + '</label><div class="descri"><span>osm_id: ' + ol.osm_id + '</span><span>osm_type: ' + ol.osm_type + '</span><span>place_id: ' + ol.place_id + '</span></div><div class="act"><a class="previewOsmSite" data-id="' + ol.place_id + '">Preview</a>' + (!that.isAddSite ? ' <a class="addOsmSite"  data-id="' + ol.place_id + '">+ Add Site</a>' : "") + '</div></div>');
            });
            that.showOsmResults();
          }
          else {
            document.querySelector('.PlaceFilter').classList.add('has-child');
            $('.osmSearchResult').html('<div style="text-align:center;padding:10px" class="no-items">No places found!</div>');
            $('.osmSearchResult').addClass('focused');
          }
        },
        error: function (error) {
          console.log(error);
        }
      });
    }
  }

  showOsmResults() {
    let that = this;
    if (document.querySelectorAll('.osmSearchResult .ositem').length > 0)
      document.querySelector('.PlaceFilter').classList.add('has-child');
    else
      document.querySelector('.PlaceFilter').classList.remove('has-child');
    $('.osmSearchResult').addClass('focused');
    window.removeEventListener("click", that.hideOsmResultView);
    document.addEventListener("click", that.hideOsmResultView);
  }

  hideOsmResultView(event) {    
    if (event.srcElement && event.srcElement.getAttribute("id") == 'searchBox')
      return;
    document.querySelector('.PlaceFilter').classList.remove('has-child');
    $('.osmSearchResult').removeClass('focused');
  }

  addUpdateGeoSite() {
    this.groupService.getAction().subscribe(data => {
      if (["addGeoSite", "editGeoSite"].includes(data.action)) {
        let obj = data.data;
        if (["addGeoSite"].includes(data.action)) {
          if (!obj.isShowGeoJson)
            this.leafLayers.push(obj.poly);
          else {
            var geoSiteObj = L.geoJSON(obj.location, { _id: obj._id }).addTo(this.editableLayers);
            this.leafLayers.push(geoSiteObj);
            delete obj.isShowGeoJson;
          }
          delete obj.poly;
          this.geoSiteList.push(obj);
          this.maxSiteAllow();
        }
        else if (["editGeoSite"].includes(data.action)) {
          this.geoSiteList = this.geoSiteList.map(function resetSite(x) {
            if (x._id == obj._id) {
              return x = obj;
            }
            return x;
          });
        }
        this.dialog.closeAll();
      } else if (["cancleGeoSite"].includes(data.action)) {
        if (!data.data._id)
          this.map.removeLayer(data.data.poly);
      }
      else if (["reSizeMap"].includes(data.action)) {
        this.map.invalidateSize();
        let that = this;
        var GooglePlacesSearchBox = L.Control.extend({
          options: {
            position: 'topleft'
          },
          onAdd: function () {
            var div: any = document.createElement("div");
            div.classList = ["PlaceFilter"];
            var sc: any = document.createElement("div");
            sc.style = "display:flex;align-items:center";
            var searchResults: any = document.createElement("div");
            searchResults.classList = ["osmSearchResult"];
            var element: any = document.createElement("input");
            element.id = "searchBox";
            element.classList = ["filter full-width"];
            element.placeholder = "Search Places";
            var anchor: any = document.createElement("a");
            anchor.id = "searchPlace";
            anchor.classList = ["find"];
            anchor.innerHTML = "<i class='fi flaticon-search'></i>";
            sc.appendChild(element);
            sc.appendChild(anchor);
            div.appendChild(sc);
            div.appendChild(searchResults);
            return div;
          }
        });
        (new GooglePlacesSearchBox).addTo(this.map);
        var input: any = document.getElementById("searchBox");

        input.addEventListener('focus', function (event) {          
          if (this.value)
            that.showOsmResults();
          that.map.doubleClickZoom.disable();
          that.map.dragging.disable();
        });

        input.addEventListener('blur', function (event) {
          that.map.doubleClickZoom.enable();
          that.map.dragging.enable();
        });

        var selectedLayer = this.leafLayers[0];
        if (selectedLayer) {
          selectedLayer.setStyle({ fillColor: '#0a93e2', color: '#0a93e2' });
          var bounds = selectedLayer.getBounds();
          this.map.fitBounds(bounds);
        }
        that.maxSiteAllow();
      }
    });
  }

  getCategoryList() {
    this.groupService.getCategoryList().subscribe(r => {
      this.categoryList = r;
    });
  }

  getSubCategoryList(id: any) {
    this.subCategoryList = [];
    this.groupService.getSubCategoryList(id).subscribe(r => {
      this.subCategoryList = r;
    });
  }

  bindGeoSites(siteData: any) {
    var _siteContainer = $('.siteResults');
    _siteContainer.empty();
    siteData.forEach(loc => {
      _siteContainer.append('<div class="site-item" id="' + loc._id + '"><div><label>' + loc.siteName + '</label><span> ' + loc.city + ', ' + loc.country + '</span></div><span>' + loc.categoryName + '-' + loc.subCategoryName + '</span><a class="regenrateView" title="Refresh View Data">&#x21bb;</a></div>');

    });
  }

  clearFilter() {
    $('.filterFields').toggleClass('hidden');
    $('#siteName').val("");
    $('#city').val("");
    $('#country').val("");
    $('#categoryid').val("");
    $('#subcategoryid').val("");
    this.bindGeoSites(this.geoSiteList)
  }

  editMap(type: any, ev: any) {
    let that = this;
    if (type == 'edit') {
      if (that.currentEdits) {
        that.currentEdits.editing.disable();
        that.map.removeLayer(that.currentEdits)
      }
      that.currentEdits = ev.layer;
      ev.layer.editing.enable();
      ev.layer.bindPopup(that.CreateEditShapeMenu(ev), { closeButton: false }).openPopup();
      // ev.layer.bindPopup(that.CreateEditShapeMenu(ev), { closeButton: false }).openPopup().on('popupclose', function () {
      //   that.currentEdits = null;
      //   that.map.removeLayer(ev.layer);
      //   let currentPolygon = that.geoSiteList.filter(x => x._id === ev.layer.options._id);
      //   if (currentPolygon.length > 0) {
      //     currentPolygon = currentPolygon[0];
      //     L.geoJSON(currentPolygon.location, { _id: currentPolygon._id }).addTo(that.editableLayers);
      //   }
      // });
    }
    else if (type == 'details') {
      let currentSite = that.geoSiteList.filter(site => site._id === ev.layer.options._id);
      that.openGeoSiteDialog(currentSite[0], ev.layer);
      that.currentEdits = null;
      ev.layer.editing.disable();
      ev.layer.closePopup();
    }
    else if (type == 'delete') {
      that.DeleteSite(ev);
    }
    else if (type == 'cancel') {
      that.currentEdits = null;
      ev.layer.editing.disable();
      ev.layer.closePopup();
    }
    else if (type == 'saveshape') {
      let currentSite = that.geoSiteList.filter(site => site._id === ev.layer.options._id);
      that.openGeoSiteDialog(currentSite[0], ev.layer);
      ev.layer.editing.disable();
      ev.layer.closePopup();
    }
    else if (type == 'cancelshape') {
      that.currentEdits = null;
      that.map.removeLayer(ev.layer);
      let currentPolygon = that.geoSiteList.filter(x => x._id === ev.layer.options._id);
      if (currentPolygon.length > 0) {
        currentPolygon = currentPolygon[0];
        L.geoJSON(currentPolygon.location, { _id: currentPolygon._id }).addTo(that.editableLayers);
      }
    }
  }

  CreateEditShapeMenu(ev) {
    let that = this;
    var div: any = document.createElement("div");
    div.classList = ['control-container'];
    var editControl = document.createElement("a");
    editControl.text = "Save Shape";
    editControl.addEventListener('click', () => { this.editMap('saveshape', ev) });
    var cancelControl = document.createElement("a");
    cancelControl.text = "Cancel";
    cancelControl.addEventListener('click', () => { this.editMap('cancelshape', ev) });
    div.appendChild(editControl);
    div.appendChild(cancelControl);
    return div;
  }

  CreateEditMenu(ev) {
    let that = this;
    var div: any = document.createElement("div");
    div.classList = ['control-container'];
    var editControl = document.createElement("a");
    editControl.text = "Edit Shape";
    editControl.addEventListener('click', () => { that.editMap('edit', ev) });
    var editDetails = document.createElement("a");
    editDetails.text = "Edit Details";
    editDetails.addEventListener('click', () => { that.editMap('details', ev) });
    var deleteControl = document.createElement("a");
    deleteControl.text = "Delete";
    deleteControl.addEventListener('click', () => { that.editMap('delete', ev) });
    var cancelControl = document.createElement("a");
    cancelControl.text = "Cancel";
    cancelControl.addEventListener('click', () => { that.editMap('cancel', ev) });
    div.appendChild(editControl);
    div.appendChild(editDetails);
    div.appendChild(deleteControl);
    div.appendChild(cancelControl);
    return div;
  }

  BindAllGeoSites() {
    this.groupService.getGeoSiteList().subscribe(
      res => {
        this.geoSiteList = res.data;
        this.geoSiteList.forEach(loc => {
          L.geoJSON(loc.location, { _id: loc._id }).addTo(this.editableLayers);
        });

        this.map.eachLayer((layer) => {
          if (layer instanceof L.Polygon || layer instanceof L.Rectangle) {
            this.leafLayers.push(layer);
          }
        });
        let userDetails = this.userService.getLoggedInUser();
        this.userExportPer = userDetails.settings;
      });
  }

  maxSiteAllow() {
    let that = this;
    if (this.userExportPer && this.userExportPer.maxSiteAllow && this.geoSiteList.length >= this.userExportPer.maxSiteAllow) {
      $(function () {
        $('body #mapsidenav-add').hide();
        $('body .leaflet-draw-draw-polygon').hide();
        $('body .leaflet-draw-draw-rectangle').hide();
        $('body .PlaceFilter').hide();
        that.isAddSite = true;
      });
    }
    else {
      $(function () {
        $('body #mapsidenav-add').show();
        $('body .leaflet-draw-draw-polygon').show();
        $('body .leaflet-draw-draw-rectangle').show();
        $('body .PlaceFilter').show();
        that.isAddSite = false;
      });
    }
  }

  DeleteSite(ev: any) {
    this.isLoadedGeo = true;
    this.groupService.deleteGeoSite({ id: ev.layer.options._id }).subscribe(
      res => {
        this.map.removeLayer(ev.layer);
        this.geoSiteList = this.geoSiteList.filter(x => x._id !== ev.layer.options._id);
        this.bindGeoSites(this.geoSiteList);
        this.maxSiteAllow();
        this.isLoadedGeo = false;
      });
  }

  openGeoSiteDialog(data: any = {}, geoJson: any) {
    if (!data.isShowGeoJson && geoJson)
      data.location = geoJson;
    this.dialog.open(GeoSitesDialog, {
      data: data,
      height: "auto",
      width: "800px",
      panelClass: "full-modal",
      disableClose: true
    });
  }
}

@Component({
  selector: "geosite-dialog",
  templateUrl: "geosite.dialog.html"
})
export class GeoSitesDialog {
  geositeForm: FormGroup;
  isSubmitted: number = 0;
  categoryList: any = [];
  subCategoryList: any = [];
  isShowGeoJson: boolean = false;
  isValidJson: boolean = false;
  isLoadedGeo: boolean = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private groupService: GroupService) { }

  ngOnInit() {
    this.isShowGeoJson = this.data.isShowGeoJson
    this.createForm(this.data);
    this.getCategoryList();
  }

  cancleGeoMap() {
    this.groupService.sendAction("cancleGeoSite", { poly: this.geositeForm.controls['location'].value, _id: this.geositeForm.controls['_id'].value });
  }

  getCategoryList() {
    this.groupService.getCategoryList().subscribe(r => {
      this.categoryList = r;
    });
  }

  getSubCategoryList(id: any, event: any) {
    if (event)
      this.geositeForm.controls['categoryName'].setValue(event.source.triggerValue);
    this.subCategoryList = [];
    this.groupService.getSubCategoryList(id).subscribe(r => {
      this.subCategoryList = r;
    });
  }

  getSubCategoryText(event: any) {
    if (event)
      this.geositeForm.controls['subCategoryName'].setValue(event.source.triggerValue);
  }

  createForm(data: GeoSite) {
    this.getSubCategoryList(data.categoryid, "");
    this.geositeForm = this.fb.group({
      _id: data._id,
      siteName: [data.siteName, Validators.required],
      city: [data.city, Validators.required],
      country: [data.country, Validators.required],
      categoryid: [data.categoryid, Validators.required],
      categoryName: [data.categoryName],
      subcategoryid: [data.subcategoryid, Validators.required],
      subCategoryName: [data.subCategoryName],
      location: [data.location],
      geoJson: [data.geoJson, Validators.compose([Validators.required])]
    });
  }

  IsValidJSONString(str: any) {
    try {
      JSON.parse(str);
      this.isValidJson = false;
    } catch (e) {
      this.isValidJson = true;
    }
  }

  onSubmit(form: any) {
    this.isLoadedGeo = true;
    let poly = form.location;
    if (this.isShowGeoJson) {
      this.IsValidJSONString(form.geoJson);
      if (this.isValidJson) return;
      form.location = poly = JSON.parse(form.geoJson);
    }
    else
      form.location = form.location.toGeoJSON().geometry;
    delete form.geoJson;
    this.isSubmitted = 1;
    this.groupService.addGeoSite(form).subscribe(
      res => {
        this.isLoadedGeo = false;
        if (form._id === undefined || form._id === "" || form._id === null) {
          form._id = res._id;
          form.poly = poly;
          if (this.isShowGeoJson)
            form.isShowGeoJson = this.isShowGeoJson;
          else
            poly.options._id = form._id;
          this.groupService.sendAction("addGeoSite", form);
        }
        else {
          this.groupService.sendAction("editGeoSite", form);
        }
      },
      error => {
        console.log(error);
      });
  }

}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/profile/geosites/geosites.component.ts